import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/Store';

export const setShowFolderPaneAsTransientOverlayMutator: (
    showFolderPaneAsTransientOverlay: boolean
) => void = mutatorAction(
    'setShowFolderPaneAsTransientOverlayMutator',
    (showFolderPaneAsTransientOverlay: boolean): void => {
        getStore().showFolderPaneAsTransientOverlay = showFolderPaneAsTransientOverlay;
    }
);

export const setShowFolderPaneAsTransientOverlay: (
    showFolderPaneAsTransientOverlay: boolean
) => void = setShowFolderPaneAsTransientOverlayMutator;
